export interface PlaceholderObj {
  placeholder: string;
  text: string;
}
export type Ignored = -1;
export class P {
  private static _placeholderRegex = /%([^%]+)%/gi;

  /**
   * Return the first placeholder match in the format %PLACEHOLDER%
   * @param str
   * @return RegExpMatchArray | null
   */
  public static match(str: string): RegExpMatchArray | null {
    const regex = P._placeholderRegex;
    const match = str.match(regex);
    if (match) {
      return match;
    }
    return null;
  }

  /**
   * check if the string has the Hide placeholder
   */
  public static isHidden(str: string): boolean {
    const match = str.match(P._placeholderRegex);
    if (match) {
      return match[0].toLowerCase().includes(PLACEHOLDERS.HideKeyword);
    }
    return false;
  }
  /**
   * Trim any placeholder in the format %PLACEHOLDER%
   * @param str
   * @return string
   */
  public static _(str: string) {
    return str.replace(P._placeholderRegex, '').trim();
  }
  /**
   * return the placeholder object in the format { placeholder: string; text: string;}
   */
  public static parse(str: string): PlaceholderObj {
    const match = P.match(str);
    if (match && match.length > 0 && match[1]?.trim()) {
      return { placeholder: match[0], text: match[1].trim() };
    }
    return { placeholder: '', text: str.trim() };
  }

  /**
   * Helper to check if a placeholder exists in the string
   * @param string
   * @returns boolean
   */
  public static contains(str: string, placeholder: string): boolean {
    const match = P.match(str);
    if (match) {
      return match[0].toLowerCase().includes(placeholder.toLowerCase());
    }
    return false;
  }
  /**
   * Helper to check if a placeholder exists in the string
   * @param string
   * @returns boolean
   */
  public static equals(str: string, placeholder: string): boolean {
    if (str.trim().toLowerCase() === placeholder.trim().toLowerCase()) {
      return true;
    }
    const match = P.match(str);
    if (match) {
      return match[0].toLowerCase() === placeholder.toLowerCase();
    }
    return false;
  }
}

export class PLACEHOLDERS {
  public static IgnoreKeyword = 'ignore';
  public static HideKeyword = 'hide_element';

  public static StyleKeyword = 'style_group';
  public static FabricKeyword = 'fabric_group';
  public static WaistbandEmbroideryKeyword = 'waistband_embroidery_group';
  public static EmbellishmentsAndSponsorsKeyword = 'embellishments_and_sponsors_group';
  public static SizeKeyword = 'size_group';
  public static TrimKeyword = 'trim_group';

  public static WaistbandEmbroideryMainBodySatinKeyword = 'waistband_embroidery_satin';
  public static WaistbandEmbroideryMainBodySpecialKeyword = 'waistband_embroidery_special';
  public static EmbellishmentsAndSponsorsSatinKeyword = 'embellishments_and_sponsors_satin';
  public static EmbellishmentsAndSponsorsSpecialKeyword = 'embellishments_and_sponsors_special';

  public static FrontAreaKeyword = 'front_waistband';
  public static BackAreaKeyword = 'back_waistband';
  public static FrontRightLegKeyword = 'front_right_leg';
  public static FrontLeftLegKeyword = 'front_left_leg';
  public static BackRightLegKeyword = 'back_right_leg';
  public static BackLeftLegKeyword = 'back_left_leg';
  public static WaistbandEmbroideryStyleKeyword = 'waistband_embroidery';
  public static StepEmbroideryColourKeyword = 'step_embroidery_colour';
}

export const PLACEHOLDERS_GROUPS = [
  'style',
  'fabric',
  'waistband embroidery',
  'embellishments & sponsors',
  'size',
];

export const PLACEHOLDERS_MAPS = {
  [PLACEHOLDERS.StyleKeyword]: PLACEHOLDERS_GROUPS[0],
  [PLACEHOLDERS.FabricKeyword]: PLACEHOLDERS_GROUPS[1],
  [PLACEHOLDERS.WaistbandEmbroideryKeyword]: PLACEHOLDERS_GROUPS[2],
  [PLACEHOLDERS.EmbellishmentsAndSponsorsKeyword]: PLACEHOLDERS_GROUPS[3],
  [PLACEHOLDERS.SizeKeyword]: PLACEHOLDERS_GROUPS[4],
};
